import { IContentFilterBlock, Subject as BaseSubject } from 'lingo2-models';

export const teacherTabs: IContentFilterBlock[] = [
  {
    order: 1,
    id: 1,
    title: 'user-profile.tab-main',
    code: 'teaching',
    type: 'subject',
    item: new BaseSubject(),
    total_count: 0,
  },
  {
    order: 2,
    id: 2,
    title: 'user-profile.tab-about-tutor',
    code: 'about',
    type: 'subject',
    item: new BaseSubject(),
    total_count: 0,
  },
  {
    order: 3,
    id: 3,
    title: 'menu.top.classes',
    code: 'classes',
    type: 'subject',
    item: new BaseSubject(),
    total_count: 0,
  },
  {
    order: 4,
    id: 4,
    title: 'user-profile.tab-lessons',
    code: 'lessons',
    type: 'subject',
    item: new BaseSubject(),
    total_count: 0,
  },
  {
    order: 5,
    id: 5,
    title: 'user-profile.tab-collections',
    code: 'collections',
    type: 'subject',
    item: new BaseSubject(),
    total_count: 0,
  },
  {
    order: 6,
    id: 6,
    title: 'user-profile.tab-schools',
    code: 'schools',
    type: 'subject',
    item: new BaseSubject(),
    total_count: 0,
  },
  {
    order: 7,
    id: 7,
    title: 'user-profile.tab-publications',
    code: 'publications',
    type: 'subject',
    item: new BaseSubject(),
    total_count: 0,
  },
  {
    order: 8,
    id: 8,
    title: 'user-profile.tab-feedback',
    code: 'feedback',
    type: 'subject',
    item: new BaseSubject(),
    total_count: 0,
  },
];

export const studentTabs: IContentFilterBlock[] = [
  {
    order: 1,
    id: 1,
    title: 'user-profile.tab-about-student',
    code: 'about',
    type: 'subject',
    item: new BaseSubject(),
    total_count: 0,
  },
  {
    order: 2,
    id: 2,
    title: 'user-profile.tab-publications',
    code: 'publications',
    type: 'subject',
    item: new BaseSubject(),
    total_count: 0,
  },
];
